import ruleHttp from './ruleHttp';
import formula from '../utils/formula.js';

const getRules = (context, tags) => {
  const tagString = tags === null || tags === undefined ? undefined : tags.join(',');

  return new Promise((resolve, reject) => {
    ruleHttp.getRules(context, tagString)
      .then(response => {
        const rules = response.body;
        const rulesUI = rules.map(rule => model2ui(rule));
        resolve(rulesUI);
      }, error => {
        reject(error);
      });
  });
};

const createRule = (context, rule) => {
  return new Promise((resolve, reject) => {
    ruleHttp.createRule(context, ui2model(rule))
      .then(response => {
        const createdRule = model2ui(response.body);
        resolve(createdRule);
      }, error => {
        reject(error);
      });
  });
};

const updateRule = (context, rule) => {
  return new Promise((resolve, reject) => {
    const requestRule = {
      id: rule.id,
      name: rule.name,
      enabled: rule.enabled,
      emails: rule.emails
    };
    ruleHttp.updateRule(context, requestRule)
      .then(response => {
        resolve(model2ui(response.body));
      }, error => {
        reject(error);
      });
  });
};

const deleteRule = (context, id) => {
  return new Promise((resolve, reject) => {
    ruleHttp.deleteRule(context, id)
      .then(() => {
        resolve();
      }, error => {
        reject(error);
      });
  });
};

const ui2model = (ruleUI) => {
  const formulas = [];
  ruleUI.varOneIds.forEach(varId => {
    const singleRule = ruleUI;
    singleRule.varOneId = varId;
    formulas.push(formula.encode(singleRule));
  });

  return {
    formulas: formulas,
    name: ruleUI.name,
    enabled: ruleUI.enabled,
    emails: ruleUI.emails
  };
};

const model2ui = (rule) => {
  const varOneIds = [];
  rule.formulas.forEach(ruleFormula => {
    varOneIds.push(formula.decode(ruleFormula).varOneId);
  });
  const ruleUI = {};
  ruleUI.constant = formula.decode(rule.formulas[0]).constant;
  ruleUI.operator = formula.decode(rule.formulas[0]).operator;
  ruleUI.varTwoId = formula.decode(rule.formulas[0]).varTwoId;
  ruleUI.timeGap = formula.decode(rule.formulas[0]).timeGap;
  ruleUI.id = rule.id;
  ruleUI.createdAt = rule.createdAt === null ? '' : new Date(rule.createdAt * 1000);
  ruleUI.owner = rule.owner;
  ruleUI.name = rule.name;
  ruleUI.varOneIds = varOneIds;
  ruleUI.enabled = rule.enabled;
  ruleUI.canEdit = rule.canEdit;
  ruleUI.canDelete = rule.canDelete;
  ruleUI.canShare = rule.canShare;
  ruleUI.emails = rule.emails === null ? '' : rule.emails;
  ruleUI.tags = rule.tags;
  ruleUI.multiple = rule.multiple;
  return ruleUI;
};

export default {
  getRules,
  createRule,
  updateRule,
  deleteRule
};



// WEBPACK FOOTER //
// ./src/api/rule/index.js